import { DocumentInfo } from '@/types/document'

export const documents: DocumentInfo[] = [
  {
    id: 'demo-interface-guide',
    title: 'Demo界面说明&线上效果对照方法',
    description: '详细介绍Demo界面的功能组件以及与线上效果进行对照的方法',
    category: '使用指南',
    tags: [],
    createdAt: '2025-09-15',
    updatedAt: '2025-09-15',
    author: 'carruswang',
    readTime: '10分钟',
    difficulty: 'beginner'
  },
  // 可以在这里添加更多文档
]

export const getDocumentById = (id: string): DocumentInfo | undefined => {
  return documents.find(doc => doc.id === id)
}

export const getDocumentsByCategory = (category: string): DocumentInfo[] => {
  return documents.filter(doc => doc.category === category)
}

export const getAllCategories = (): string[] => {
  return Array.from(new Set(documents.map(doc => doc.category)))
}
